(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Custom-Tabs"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-custom-tabs]').forEach(function (tabRoot) {
    var tabs = Array.from(tabRoot.querySelectorAll('[role="tab"]'));

    function activateTab(nextTab) {
      tabs.forEach(function (tab) {
        var isActive = tab === nextTab;
        var panel = tabRoot.querySelector('#' + CSS.escape(tab.getAttribute('aria-controls')));
        tab.setAttribute('aria-selected', String(isActive));
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
        if (panel) panel.hidden = !isActive;
      });
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activateTab(tab);
      });

      tab.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        var direction = event.key === 'ArrowRight' ? 1 : -1;
        var nextTab = tabs[(index + direction + tabs.length) % tabs.length];
        activateTab(nextTab);
        nextTab.focus();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        window.pauseAllMedia();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const alignHeaderSubmenu = (details) => {
    const submenu = details.querySelector(':scope > .header__submenu');
    if (!submenu) return;
    submenu.classList.remove('is-edge-aligned');
    if (submenu.getBoundingClientRect().right > window.innerWidth - 16) {
      submenu.classList.add('is-edge-aligned');
    }
  };

  document.querySelectorAll('#shopify-section-header .header__inline-menu > .list-menu--inline > li > details-disclosure > details').forEach((details) => {
    details.addEventListener('toggle', () => {
      if (!details.open || !window.matchMedia('(min-width: 1200px)').matches) return;
      details.closest('.list-menu--inline')?.querySelectorAll(':scope > li > details-disclosure > details[open]').forEach((openDetails) => {
        if (openDetails !== details) openDetails.removeAttribute('open');
      });
      window.requestAnimationFrame(() => alignHeaderSubmenu(details));
    });
  });

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.header.querySelector('header-drawer > details[open], details-modal > details[open]')) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.header.querySelector('header-drawer > details[open], details-modal > details[open]')) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      if (!activeMedia) return;

      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      const container = this.querySelector('[role="document"]');

      activeMedia.classList.add('active');

      if (container) {
        window.requestAnimationFrame(() => {
          const containerTop = container.getBoundingClientRect().top;
          const mediaTop = activeMedia.getBoundingClientRect().top;
          container.scrollTo({
            top: container.scrollTop + mediaTop - containerTop,
            left: 0,
            behavior: 'auto'
          });
          container.focus({ preventScroll: true });
        });
      }

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  class ProductMediaThumbs extends HTMLElement {
    constructor() {
      super();
      this.sliderComponent = this.closest('slider-component');
      this.slider = this.sliderComponent ? this.sliderComponent.querySelector('.product__media-list') : null;
      this.buttons = Array.from(this.querySelectorAll('[data-target-media-id]'));
      this.adaptHeight = Boolean(this.closest('.j-product--package') || this.slider?.querySelector('.j-ribeye-detail-slide, .j-cut-guide-slide, .j-gallery-parcel'));
      this.slides = this.slider ? Array.from(this.slider.querySelectorAll(':scope > [data-media-id]')) : [];

      if (!this.slider || this.buttons.length === 0 || this.slides.length === 0) return;

      // These gallery slides fill the viewport; Dawn's carousel inset would
      // leave the previous image showing and crop the selected slide.
      this.slider.style.scrollPaddingInlineStart = '0px';

      this.buttons.forEach((button, index) => {
        button.addEventListener('click', this.onThumbClick.bind(this));
        button.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.buttons.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + this.buttons.length) % this.buttons.length;
          this.buttons[next].focus({ preventScroll: true });
          this.buttons[next].click();
        });
      });

      this.slider.addEventListener('scroll', this.requestUpdate.bind(this), { passive: true });
      this.updateActiveThumb();
      if (this.adaptHeight && window.ResizeObserver) {
        this.sizeObserver = new ResizeObserver(() => this.requestUpdate());
        this.slides.forEach(slide => this.sizeObserver.observe(slide));
      }
    }

    disconnectedCallback() {
      this.sizeObserver?.disconnect();
    }

    onThumbClick(event) {
      event.preventDefault();
      const targetId = event.currentTarget.getAttribute('data-target-media-id');
      const targetSlide = this.slides.find((slide) => slide.getAttribute('data-media-id') === targetId);

      if (!targetSlide) return;

      // Set the target height before scrolling. Smooth scrolling can be
      // interrupted by the height/snap updates of differently sized slides.
      this.setActiveThumb(targetId);
      this.slider.scrollTo({
        left: targetSlide.offsetLeft,
        behavior: 'instant'
      });
      if (this.adaptHeight && this.slider.getBoundingClientRect().top < 110) {
        window.scrollTo({ top: window.scrollY + this.slider.getBoundingClientRect().top - 110, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
    }

    requestUpdate() {
      if (this.updateFrame) return;

      this.updateFrame = window.requestAnimationFrame(() => {
        this.updateFrame = null;
        this.updateActiveThumb();
      });
    }

    updateActiveThumb() {
      const currentSlide = this.slides.reduce((nearest, slide) => {
        if (!nearest) return slide;

        const slideDistance = Math.abs(slide.offsetLeft - this.slider.scrollLeft);
        const nearestDistance = Math.abs(nearest.offsetLeft - this.slider.scrollLeft);
        return slideDistance < nearestDistance ? slide : nearest;
      }, null);

      if (!currentSlide) return;

      this.setActiveThumb(currentSlide.getAttribute('data-media-id'));
    }

    setActiveThumb(mediaId) {
      let activeButton = null;
      if (this.adaptHeight) {
        const activeSlide = this.slides.find(slide => slide.dataset.mediaId === mediaId);
        if (activeSlide) this.slider.style.height = `${activeSlide.offsetHeight}px`;
      }

      this.buttons.forEach((button) => {
        const isActive = button.getAttribute('data-target-media-id') === mediaId;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-current', isActive ? 'true' : 'false');

        if (isActive) activeButton = button;
      });

      if (activeButton) {
        // Keep the active thumbnail in its own horizontal strip. Never scroll
        // the document to the gallery on initialisation or variant changes.
        const left = activeButton.getBoundingClientRect().left - this.getBoundingClientRect().left + this.scrollLeft;
        const right = left + activeButton.offsetWidth;
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        if (left < this.scrollLeft) this.scrollTo({ left, behavior });
        else if (right > this.scrollLeft + this.clientWidth) this.scrollTo({ left: right - this.clientWidth, behavior });
      }
    }
  }

  customElements.define('product-media-thumbs', ProductMediaThumbs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
